import React from 'react';

import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import { StyledCircularProgress } from './CustomTextButton.styles';

import { StyledButton } from './CustomTextButton.styles';

const CustomTextButton = ({
  text = '',
  icon: Icon = null,
  onClick,
  isUsingParentBackground = false,
  hasInfoIcon = false,
  infoTooltipText = '',
  disabled = false,
  isLoading = false,
}) => {
  return (
    <StyledButton
      startIcon={Icon ? <Icon /> : null}
      onClick={onClick || null}
      className={isUsingParentBackground ? 'use-parent-background' : ''}
      disabled={disabled || isLoading}
    >
      {text}
      {isLoading && <StyledCircularProgress size={20} />}
      {!isLoading && hasInfoIcon && (
        <Tooltip title={infoTooltipText} arrow placement="top">
          <InfoOutlinedIcon fontSize="small" />
        </Tooltip>
      )}
    </StyledButton>
  );
};

CustomTextButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.elementType,
  onClick: PropTypes.func,
  isUsingParentBackground: PropTypes.bool,
  hasInfoIcon: PropTypes.bool,
  infoTooltipText: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default CustomTextButton;
